import { createSelector } from "reselect";

export const getRequesting = ({ FileUploader_reducer }) => {
    return FileUploader_reducer.requesting;
};
export const getAllFiles = ({ FileUploader_reducer }) => {
    return FileUploader_reducer.files;
};
export const selectFolders = ({ FileUploader_reducer }) => {
    return FileUploader_reducer.folders;
};
export const selectedFolder = ({ FileUploader_reducer }) => {
    return FileUploader_reducer.selectedFolder;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["file_manager"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectFiles = createSelector(
    [getAllFiles, selectedFolder],
    (files = false, folder = false) => {
        if (files) {
            return folder ? files[folder] || {} : false;
        } else return false;
    }
);
export const selectCurrNames = createSelector(
    [selectFiles],
    (files = false) => {
        if (files) {
            return Object.keys(files).map((e) => files[e].file_name);
        } else return [];
    }
);
